<template>
    <x-modal :title="title"
             :visible="showDialog"
             :loading="loading"
             @open="handleOpen"
             @close="clickClose"
             width="560px">
        <div class="row" v-loading="loading">
            <div class="col-12 table-responsive">
                <table class="table text-left">
                    <thead>
                    <tr>
                        <th class="text-left" style="width: 100px">Fecha</th>
                        <th class="text-left" style="width: 100px">Monto</th>
                        <th style="width: 30px"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(row, index) in fee" :key="index">
                        <td>
                            <el-date-picker v-model="row.date"
                                            :picker-options="dateFee"
                                            :clearable="false"
                                            format="dd/MM/yyyy"
                                            type="date"
                                            value-format="yyyy-MM-dd"></el-date-picker>
                        </td>
                        <td>
                            <x-input v-model="row.amount"></x-input>
                        </td>
                        <td class="text-center">
                            <button v-if="index > 0"
                                    class="btn waves-effect waves-light btn-xs btn-danger"
                                    type="button"
                                    @click.prevent="clickRemoveFee(index)">
                                <i class="fa fa-trash"></i>
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-12 text-center">
                <a href="#"
                   @click.prevent="clickAddFee">
                    <i class="fa fa-plus font-weight-bold text-info"></i>
                    <span style="color: #777777">Agregar cuota</span>
                </a>
            </div>
            <div class="col-md-12 btn-actions">
                <x-button-cancel @click="clickClose" text="Cerrar"></x-button-cancel>
                <x-button-submit @click="onSubmit" text="Generar"></x-button-submit>
            </div>
        </div>
    </x-modal>
</template>

<script>

import XButtonCancel from "../../../../components/Form/XButtonCancel";
import XButtonSubmit from "../../../../components/Form/XButtonSubmit";
import XModal from "../../../../components/XModal";
import XInput from "../../../../components/Form/XInput.vue";
import XSelect from "../../../../components/Form/XSelect.vue";
import XDatePicker from "../../../../components/Form/XDatePicker.vue";
import XInputItemSearch from "../../../../components/Form/XInputItemSearch.vue";
import moment from "moment/moment";

export default {
    name: 'DocumentFee',
    components: {XInputItemSearch, XDatePicker, XSelect, XInput, XModal, XButtonSubmit, XButtonCancel},
    props: {
        showDialog: {
            type: Boolean,
            default: false,
        },
        data: {
            type: Object
        },
        showLoadVoucher: {
            type: Boolean,
            default: true,
        }
    },
    data() {
        return {
            title: null,
            loading: false,
            resource: 'store',
            errors: {},
            fee: [],
            dateFee: {
                disabledDate(time) {
                    return time.getTime() <= moment();
                }
            },
        }
    },
    created() {
        this.initForm();
        // this.initTables();
    },
    methods: {
        initForm() {
            this.title = '';
            this.errors = {};
            this.fee = [];
        },
        handleOpen() {
            this.initForm();
            this.clickAddFee();
            this.title = 'Registrar Cuotas';
        },
        clickAddFee() {
            let date = moment().add(1, 'months').add(1, 'days').format('YYYY-MM-DD');
            let fee_last = _.last(this.fee);
            if (fee_last) {
                date = moment(fee_last.date).add(1, 'months').format('YYYY-MM-DD')
            }
            this.fee.push({
                id: null,
                date: date,
                currency_type_id: this.data.currency_type_id,
                amount: 0,
            });
            this.calculateFee();
        },
        clickRemoveFee(index) {
            this.fee.splice(index, 1);
            this.calculateFee();
        },
        calculateFee() {
            let fee_count = this.fee.length;
            let total = this.data.total_payment

            let accumulated = 0;
            let amount = _.round(total / fee_count, 2);
            _.forEach(this.fee, row => {
                accumulated += amount;
                if (total - accumulated < 0) {
                    amount = _.round(total - accumulated + amount, 2);
                }
                row.amount = amount;
            })
        },
        onSubmit() {
            this.clickClose();
            this.$emit('success', this.fee)
        },
        clickClose() {
            this.$emit('update:showDialog', false)
        }
    }
}
</script>
